import baseURL from "../common/axios";
class Commonservices {
  GetMenus(Type, RoleId, OrganizationId) {
    debugger;
    return baseURL.httpMSInventoryUrl.get(
      "Menu/GetMenuSubMenuList?Type=" +
        Type +
        "&RoleId=" +
        RoleId +
        "&OrganizationId=" +
        OrganizationId +
        ""
    );
  }
  CheckMenuRights(EntityId, RoleId) {
    debugger;
    return baseURL.httpMSInventoryUrl.get(
      "EntityOperationsDeptRoleMap/CheckMenuRights?EntityId=" +
        EntityId +
        "&RoleId=" +
        RoleId +
        ""
    );
  }
}
export default new Commonservices();
